import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store/store";

export const getState = (state: RootState) => state.registrationPage;

export const getUserInfo = createSelector(getState, (userState) => userState.user_info);
export const getIsLoading = createSelector(getState, (userState) => userState.isLoading);
export const getHasFigmaToken = createSelector(getState, (userState) => userState.hasFigmaToken);
